









import * as echarts from 'echarts';
import ResizeMixin from '@/components/Charts/mixins/resize';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'countryDistributionBar',
})
export default class extends Mixins(ResizeMixin) {
  @Prop({ default: 'bar-chart' }) public className!: string;
  @Prop({ default: '480px' }) public height!: string;
  @Prop({ default: {} }) public data!: any;

  get year() {
    return UserModule.indexSelectYear;
  }

  get language() {
    return AppModule.language;
  }

  get getSeriesData() {
    return this.data.applyNums;
  }

  public chart: any = null;
  public xAxis: any = [];
  public legendDataType: any[] = [];
  public valueConfigs: any[] = [];

  @Watch('language')
  @Watch('year')
  @Watch('data', { deep: true })
  public watchNum(val: any) {
    if (!this.chart) {
      this.initChart();
    }
    if (this.chart && (val === null || val === undefined || val === '')) {
      this.chart.clear();
    } else {
      this.setEchartsOptions();
    }
  }

  public mounted() {
    this.$nextTick(() => {
      this.initChart();
      this.setEchartsOptions();
    })
  }

  public beforeDestroy() {
    if (!this.chart) {
      return;
    }
    // 销毁实例，实例销毁后无法再被使用
    this.chart.dispose();
    this.chart = null;
  }

  public initChart() {
    const barChartDom = this.$refs.barChartCountry;
    this.chart = echarts.init(barChartDom as HTMLDivElement);
  }

  public countryObj() {
    let countryNames = null;
    if (this.language === 'zh' || this.language === 'zh-hk') {
      countryNames = this.data.countryNameCns;
    } else {
      countryNames = this.data.countryNames;
    }
    if (countryNames && countryNames.length) {
      const countryObj: any = {};
      countryNames.map((name: any) => {
        const nameArr = name.split('#')
        if (nameArr && nameArr.length === 2) {
          countryObj[nameArr[1]] = nameArr[0];
        }
      })
      return countryObj;
    }
    return [];
  }

  public setEchartsOptions() {
    const xAxis = Object.keys(this.countryObj());
    this.chart.setOption({
      grid: {
        bottom: '20',
        containLabel: true
      },
      yAxis: [{
        type: 'value',
      }],
      xAxis: {
        type: 'category',
        data: xAxis,
        axisLabel: { interval: 0, rotate: 60 }
      },
      series: [
        {
          type: 'bar',
          data: this.getSeriesData
        }
      ]
    }, {replaceMerge: ['series']});
    this.chart.on('click', (params: any) => {
      console.log(params);
      const countryName = params.name;
      const countryId = this.countryObj()[countryName];
      let ctry = countryName;
      if (this.language === 'zh' || this.language === 'zh-hk') {
        ctry = this.data.countryNames[params.dataIndex].split('#')[1]
      }
      const year = this.year;
      if (year !== '0') {
        const endTime = `${year}-12-${new Date(Number(year), 12, 0).getDate()}`;
        const startTime = `${year}-1-1`
        this.$router.push({ name: 'applicationList', query: { startTime: startTime.toString(), endTime: endTime.toString(), ctryId: countryId, ctry } })
      } else {
        this.$message.warning(this.$t('message.businessOverviewMessage') as string);
      }
    });
  }
}
